import React from 'react';
import MobileView from '../../Components/MobileView';
import Style from './index.module.scss';
import {useParams} from 'react-router-dom';
const Index = () => {
    const {url} = useParams<{url: string}>();
    const src = `//${url}`;
    return (
        <div className={Style.view}>
            <MobileView src={src} />
            <a href={src}>跳转到此网站</a>
        </div>
    );
};

export default Index;
